export default "__VITE_ASSET__c6583467__"